const changePasswordStr = {
  toastr: 'Password changed',
  toastr1: 'password changed successfully',
  toastrError: 'Incorrect password',
  toastrError1: 'Old password does not match'
};

export default changePasswordStr;
